// =====================================
//
//   resendInvitation Modal
//   Author: Gray
//   createtime: 2016 / 09 / 02
//
// =====================================

window.InifECMobileApp.directive('resendInvitation', ['$rootScope', '$stateParams', '$timeout', '$ngModal', 'UserService', '$InifECGA',
    function($rootScope, $stateParams, $timeout, $ngModal, UserService, $InifECGA) {

        var _dir = {};

        var controller = ['$scope', function($scope) {

            var resendInvitaion = function(){
                
                if($scope.isSendding) {
                    return;
                }

                $scope.isEmailError = false;
                $scope.isMemberNotExist = false;
                $scope.isMember = false;
                $scope.isSystemError = false;

                if(!$scope.form.email || !isEmail($scope.form.email)){
                    $scope.isEmailError = true;
                    return;
                }

                $scope.isSendding = true;

                UserService.resendInvitaion($scope.form.email).then(function(){
                    $scope.isSendding = false;
                    $scope.isSuccess = true;

                    $timeout(function(){
                        const mrscid = UserService.user.mrscid;
                        $InifECGA.eventTrack('register', { category: 'member', label: mrscid });
                        $InifECGA.eventTrack('email_register', { category: 'member', label: mrscid });
                    },1000);

                }, function(error){
                    $scope.isSendding = false;
                    if(error.code === 'error.apply.applicationSuccess'){
                        $scope.isMember = true;
                    }else if(error.code === 'error.apply.noApplied'){
                        $scope.isMemberNotExist = true;
                    }else{
                        $scope.isSystemError = true;
                    }
                });
            }

            var openModal = function() {
                $ngModal.openModal('resend-invitation-modal');
            }

            var closeModal = function() {
                $ngModal.closeModal('resend-invitation-modal');
            }

            var init = function() {

            }

            /*==========================
                Events
            ==========================*/
            $scope.$on('OPEN_RESEND_INVITATION_MODAL', function(event, data) {

                $scope.form.email = '';

                if(data) {
                    $scope.form.email = data.email;
                }

                openModal();
            })

                
            /*==========================
                Members
            ==========================*/

            $scope.form = {
                email: ''
            };
            $scope.isSendding = false;
            $scope.isEmailEmpty = false;
            $scope.isEmailError = false; // error.formValidator.invalidMailFormat
            $scope.isMember = false; // error.apply.applicationSuccess
            $scope.isMemberNotExist = false; // error.account.accountNotExist
            $scope.isSystemError = false;
            $scope.isSuccess = false;

            /*==========================
                Methods
            ==========================*/

            $scope.resendInvitaion = resendInvitaion;

            /*==========================
                init
            ==========================*/

            init();

        }]

        _dir.restrict = 'E';
        _dir.scope = true;
        _dir.templateUrl = 'mobile/partials/modal/resend_invitation.html';
        _dir.controller = controller;

        return _dir;
}]);